module.exports = __webpack_public_path__ + "img/stock.89135f2.webp";